<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Kingsport Speedway</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head" id="Ack">ACKNOWLEDGMENTS</p>
<p class="para1">The author gratefully acknowledges the enthusiastic support of Kingsport Speedway promoter Karen Tunnell, owner Joe Loven, and track operators Keith Stiltner and Ervin Stiltner. Without their desire to help preserve this unique slice of American auto-racing history and heritage, information might have remained forever scattered on the wind.</p>
<p class="para">Documenting 50 years is a massive undertaking when accurate records are scant. Saying “thank you” cannot begin to express my appreciation to Robert Walden, John A. Utsman, Randall Perry, Tony Morton, Kenny Hunley, Robbie Henry, Chris Haverly, Melvin Corum, Rusty and Beth Clendenin, Jeff Birchfield, and David Allio, whose recollections, photographs, and insight proved invaluable while preparing this work.</p>
<p class="para">In addition, thanks also go to John Beach, Drew Hierwarter, Michael Moats, the Murray family, Mike O’Dell, and Ray Taylor for their photographs—as well as to some unidentified photographers whose images document moments in time.</p>
<p class="para">Special thanks go to Debbie Helton for her support and encouragement and to fellow author and friend Joe Tennis, who always provided great advice.</p>
<p class="para">My appreciation goes out to all of the drivers, track staff, fans, and others who shared memories and words of encouragement.</p>
<p class="para">A thank-you goes to the folks at East Tennessee State University’s Charles Sherrod Library for invaluable access to long-forgotten nuances buried on decades-old microfilm. And my undying gratitude goes to the former sportswriters of the <i>Kingsport Times News</i> and <i>Bristol Herald Courier</i>, who faithfully documented races—especially my friends Kenny Bruce, Bill Lane, and the late, great Denny Darnell.</p>
<p class="para">Finally, a huge thank-you goes to everyone at Arcadia Publishing, especially Maggie Bullwinkel, for her support and guidance. This is our third project together and, I believe, some of our best work.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?1aeb4192